import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Can } from '@app/context/ability-context'
import StatisticsTable from '@app/components/shared/Statistics/Table'
import ClassTabs from './components/ClassTabs'

const Leaders = ({
 classes,
 activeClassId,
 group,
 olympiad,
 route,
 ability,
 event,
 onClassChange
}) => {
  if (!group || !olympiad) return null

  return (
    <Fragment>
      <ClassTabs
        classes={classes}
        activeClassId={activeClassId}
        onClassChange={onClassChange}
      />
      <div className="plate plate--xxl">
          <StatisticsTable
            olympiad={olympiad}
            tasks={olympiad.mainCards}
            group={group}
            event={event}
            tour='main'
          />
          <div className="separator" />
      </div>
    </Fragment>
  )
}

Leaders.propTypes = {
  classes: PropTypes.array.isRequired,
  activeClassId: PropTypes.string,
  group: PropTypes.object,
  olympiad: PropTypes.object,
  route: PropTypes.object.isRequired,
  ability: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  onClassChange: PropTypes.func.isRequired
}

export default Leaders